export function isFeatureFlagEnabled(
  enabledFlags: string[] | undefined,
  flagKey: string
): boolean {
  if (!enabledFlags) {
    return false;
  }
  return enabledFlags.includes(flagKey);
}
